module.exports = __webpack_public_path__ + "static/img/1600.806b3be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s33/pop/1600.png
// module id = u/fL
// module chunks = 2